import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "AffectationCategorieModal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "AffectationCategorieModalLabel",
  "aria-hidden": "true",
  ref: "modalRef"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered modal-md",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", _hoisted_5, " Affecter une catégorie client à " + _toDisplayString(_ctx.selectedClient?.nomClient || "un client") + " " + _toDisplayString(_ctx.selectedClient?.prenomClient || ""), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close py-0",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Form, {
            ref: "affectationForm",
            "validation-schema": _ctx.affectationSchema,
            onSubmit: _ctx.handleSubmit
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Client "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "clientId" }, {
                      default: _withCtx(({ field, errors }) => [
                        _createVNode(_component_Multiselect, {
                          modelValue: _ctx.selectedClientId,
                          "onUpdate:modelValue": [
                            _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedClientId) = $event)),
                            ($event: any) => (field.onChange($event))
                          ],
                          options: _ctx.clientOptions,
                          "preserve-search": true,
                          multiple: false,
                          searchable: true,
                          placeholder: "Sélectionner le client",
                          label: "label",
                          "track-by": "value",
                          class: _normalizeClass({ 'is-invalid': errors.length }),
                          disabled: true
                        }, null, 8, ["modelValue", "options", "class", "onUpdate:modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "clientId",
                          class: "text-danger"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Catégorie Client "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "categorieClientId" }, {
                      default: _withCtx(({ field, errors }) => [
                        _createVNode(_component_Multiselect, {
                          modelValue: _ctx.selectedCategorieClientId,
                          "onUpdate:modelValue": [
                            _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedCategorieClientId) = $event)),
                            ($event: any) => (field.onChange($event))
                          ],
                          options: _ctx.categorieClientsOptions,
                          "preserve-search": true,
                          multiple: false,
                          searchable: true,
                          placeholder: "Sélectionner une catégorie client",
                          label: "label",
                          "track-by": "value",
                          class: _normalizeClass({ 'is-invalid': errors.length })
                        }, null, 8, ["modelValue", "options", "class", "onUpdate:modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "categorieClientId",
                          class: "text-danger"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-secondary me-2",
                      "data-bs-dismiss": "modal",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
                    }, " Annuler "),
                    _cache[6] || (_cache[6] = _createElementVNode("button", {
                      type: "submit",
                      class: "btn btn-primary"
                    }, " Affecter ", -1))
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["validation-schema", "onSubmit"])
        ])
      ])
    ])
  ], 512))
}